// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tCa9z","rootNoMargin":"styles_rootNoMargin__2svJs"};